export const COOKIE_KEYS = {
  /** Session storage uses the same name via `LEFT_SIDEBAR_LAYOUT_PERSISTENCE_KEY` in ViewStore. */
  leftSidebarState: "corca.leftSidebarState",
  rightSidebarState: "corca.rightSidebarState",
  floatingChatInputHidden: "corca.floatingChatInputHidden",
} as const;
